import React, { Component } from "react";
import { Container,Col ,Row,UncontrolledDropdown ,DropdownToggle,DropdownMenu,Form} from "reactstrap";
import Calender from '../calender';
import { withRouter } from "react-router-dom";
import {connect } from 'react-redux';
import 'bootstrap'


class AdvencedSearchGhurfaty extends Component {
  constructor(props) {
    super(props);

    this.onFormSubmit = this.onFormSubmit.bind(this);        

  }
	state = {
		advancedSearch: { destination: '',startDate:'',endDate:'',nbrChambres:1,nbrEnfant:0,nbrAdultes:1},
    clikedDetailInput:false
	}

  onInputChange(evt) {
		this.setState({
			advancedSearch: {
				...this.state.advancedSearch,
				[evt.target.name]: evt.target.value
			}
		})
	}

	onFormSubmit(evt) {
		evt.preventDefault()
    const params = this.state.advancedSearch
    this.props.dispatch({type: "ADVANCED_SEARCH_HEBERG",payload:this.state.advancedSearch});
    this.props.history.push(`/hebergement/advanced_search?adult=${params.nbrAdultes||1}&enfant=${params.nbrEnfant||1}&room=${params.nbrChambres||1}&pays=Algerie&region=${params.destination}`);	
  }
    render() { 
      const {nbrChambres, nbrEnfant, nbrAdultes} = this.state.advancedSearch
      const DetailOrInfo = this.state.clikedDetailInput ? `${nbrAdultes} Adlt - ${nbrEnfant} Enf - ${nbrChambres} Chambre` : "Détails"

        return ( 
          <>

        <Container>
        <Form onChange={this.onInputChange.bind(this)} >
            <Row className="d-flex">
              <Col sm="4" className="pr-0 ">
                <div className="destination-input mb-1">
                <UncontrolledDropdown nav inNavbar>
                <input type="text" name="destination" className="left-radius filter-element" placeholder=" Votre Destination"/>
                  </UncontrolledDropdown>
                </div>
              </Col>
              <Col sm="3" className=" pl-sm-0 pr-lg-0">
                <div className=" " style={{marginTop:"1px"}}>
                <UncontrolledDropdown nav inNavbar>
                    <Calender  returnBool={true} num={0} style={{marginTop:"10px",padding:"0"}}/>
                  </UncontrolledDropdown>
                </div>
              </Col>
              <Col sm="3" className=" pr-xs-0 pr-lg-0 p-sm-0" >
                <div className="destination-input  pr-3">
                <UncontrolledDropdown nav inNavbar onClick={()=>{this.setState({clikedDetailInput:true})}}>
                    <DropdownToggle id="destination" className="filter-element right-radius" style={{width:"100%",backgroundColor:"white",color:"#182952",textAlign:"left",fontWeight:"300"}}>
                      {/* <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/> */}
                      {DetailOrInfo}
                    </DropdownToggle>
                    <DropdownMenu left className="full-width">
                      <div className="d-flex justify-content-between col-7 mb-2">
                        <span className="label-detail-search">Adultes </span>
                        <input className="detail-input" min="1" defaultValue = "1" type="number" name="nbrAdultes" value={nbrAdultes}/>
                      </div>
                      <div className="d-flex justify-content-between col-7 mb-2">
                        <span className="label-detail-search">enfant </span>
                        <input className="detail-input" min="0" defaultValue = "1" type="number" name="nbrEnfant" value={nbrEnfant}/>
                      </div>
                      <div className="d-flex justify-content-between col-7">
                        <span className="label-detail-search">Chambres </span>
                        <input className="detail-input" min="1" defaultValue = "1" type="number" name="nbrChambres" value={nbrChambres}/>
                      </div>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </Col>
              <Col sm="2" className="p-0 p-sm-0">
                <div className="destination-input ">
                <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle  className="filter-element-search"   onClick={this.onFormSubmit.bind(this)}>
                      Recherche
                      <img src="/imgs/navebar/search.svg" alt="" id="recherche"/>

                    </DropdownToggle>
                  </UncontrolledDropdown>
                </div>
              </Col>
            </Row>
            </Form>
        </Container>

        </>
         );
    }
}
 
function mapStateToProps(state) {
  return {
    // startDate: state.counterApp.startDate,
    // endDate: state.counterApp.endDate,
  }
}
//connect function INJECTS dispatch function as a prop!!
// export default connect(mapStateToProps)(AdvencedSearchGhurfaty);
export default withRouter(connect(mapStateToProps)(AdvencedSearchGhurfaty));

